"use client"

import { useState, useEffect } from "react"
import { BillingModal } from "./BillingModal"

interface BillingErrorComponentProps {
  errorMessage: string
  onBeforePurchase?: () => void // Added callback prop to pass through to BillingModal
}

export function BillingErrorComponent({ errorMessage, onBeforePurchase }: BillingErrorComponentProps) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  console.log("[v0] BillingErrorComponent rendered:", {
    hasCallback: !!onBeforePurchase,
    errorMessage,
    isModalOpen,
  })
  // </CHANGE>

  useEffect(() => {
    console.log("[v0] BillingErrorComponent mounted, opening modal")
    setIsModalOpen(true)
  }, [])

  const currentUrl = typeof window !== "undefined" ? window.location.pathname : ""

  return (
    <BillingModal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      returnUrl={currentUrl}
      onBeforePurchase={onBeforePurchase} // Pass callback through to BillingModal
    />
  )
}
